import "bootstrap/dist/css/bootstrap.min.css";
import AllRoutes from "./app/Routes/allRoutes";
import 'react-quill/dist/quill.snow.css';

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
